import './outer_layout';

import '../modules/registration/registration_input';
import '../components/checkbox';
import '../modules/registration/form_validation';
import '../modules/login/login';
